// @flow

import { getHeaders, hpfetchWithoutContentType } from '../util';
import type { wrappedApiResponseType } from '../apiTypes';

export const get = () =>
  hpfetchWithoutContentType('auth/user/').then(res => ({
    ...res,
    body: {
      ...res.body,
      id: res.body.pk,
    },
  }));

export const registrationV2 = (
  username: string,
  email: string,
  password1: string,
  password2: string,
  referrer_code: string | null,
): Promise<wrappedApiResponseType<{ key: string }>> => {
  const form = new FormData();

  form.append('email', email);
  form.append('username', username);
  form.append('password1', password1);
  form.append('password2', password2);
  if (referrer_code) {
    form.append('referrer_code', referrer_code);
  }

  return hpfetchWithoutContentType('auth/registration/', {
    headers: getHeaders(),
    method: 'POST',
    body: form,
  });
};

export const registerChildAccount = (
  username: string,
  email: string,
  password1: string,
  password2: string,
  key?: string,
): Promise<wrappedApiResponseType<{ key: string }>> => {
  const form = new FormData();

  form.append('email', email);
  form.append('username', username);
  form.append('password1', password1);
  form.append('password2', password2);

  return hpfetchWithoutContentType('auth/child-registration/', {
    headers: {
      ...getHeaders(),
      // $FlowFixMe
      ...(key ? { Authorization: `Token ${key}` } : {}),
    },
    method: 'POST',
    body: form,
  });
};

export const loginV2 = (
  usernameOrEmail: string,
  password: string,
): Promise<wrappedApiResponseType<{ key: string }>> => {
  const form = new FormData();

  // if (usernameOrEmail.indexOf('@') !== -1) {
  form.append('email', usernameOrEmail);
  // } else {
  //   form.append('username', usernameOrEmail)
  // }

  form.append('password', password);

  return hpfetchWithoutContentType('auth/login/', {
    method: 'POST',
    body: form,
  });
};

export const verifyEmail = (key: string) => {
  const form = new FormData();
  form.append('key', key);

  return hpfetchWithoutContentType('auth/registration/verify-email/', {
    method: 'POST',
    body: form,
  });
};

export const passwordChange = (
  old_password: string,
  new_password1: string,
  new_password2: string,
) => {
  const form = new FormData();
  form.append('old_password', old_password);
  form.append('new_password1', new_password1);
  form.append('new_password2', new_password2);

  return hpfetchWithoutContentType('auth/password/change/', {
    headers: getHeaders(),
    method: 'POST',
    body: form,
  });
};

export const passwordReset = (email: string) => {
  const form = new FormData();
  form.append('email', email);

  return hpfetchWithoutContentType('auth/password/reset/', {
    method: 'POST',
    body: form,
  });
};

export const passwordResetConfirm = (
  new_password1: string,
  new_password2: string,
  uid: string,
  token: string,
) => {
  const form = new FormData();
  form.append('new_password1', new_password1);
  form.append('new_password2', new_password2);
  form.append('uid', uid);
  form.append('token', token);

  return hpfetchWithoutContentType('auth/password/reset/confirm/', {
    method: 'POST',
    body: form,
  });
};
